<template>
  <div >
    <el-drawer @reload="$reloadHandle" title="回访信息" size="40%" :before-close="handleClose" :visible.sync="drawer"
               direction="rtl" append-to-body  custom-class="demo-drawer" ref="drawer" class="details2">

      <div class="demo-drawer__content">



        <template>
          <div>
            <div class="detail-wrap">
              <el-form ref="editForm" :model="formData">

                <el-form-item label="回访情况" label-width="120px">
                  <el-radio-group v-model="formData.huiFangQingKuang" @change="radioHandleChange">
                          <el-radio v-model="radio" :label="1">属实</el-radio>
                          <el-radio v-model="radio" :label="2">不属实</el-radio>
                          <el-radio v-model="radio" :label="3">不确定</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="不属实原因名称" label-width="120px">
                  <el-select v-model="formData.notTrueReason" :disabled="isdisabledSite" placeholder="" @change="updateNotTrueName">
                    <el-option v-for="item in notTrueReasonList" :key="item.value" :label="item.label"
                               :value="item.value"/>
                  </el-select>
                </el-form-item>
                <el-form-item label="回访描述" label-width="120px">
                  <el-input class="annotate" type="textarea"  placeholder="请输入内容" size="small" style="width: 90%"
                            v-model="formData.recallRemark" clearable  ></el-input>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </template>
        <div class="demo-drawer__footer" style="position: absolute;
    bottom: 5px;
    right: 5px;">
          <el-button @click="cancelForm">取 消</el-button>
          <el-button type="primary" @click="orderFollowUp">
            确 定
          </el-button>
        </div>
      </div>
    </el-drawer>

    <!-- 关闭弹窗 -->

  </div>
</template>
<script>
import request from "@/router/axios";
import api from "@/api/projectApi";
import {dictType, loadDictData} from "@/config/dictType";
import store from "@/store";
export default {
  inject: ['reload'],
  name: 'edit',
  props: ['multi','param' ],
  components: {

  },
  created(){
    this.dataId= this.param?this.param.orderId?this.param.orderId:'':''
    this.showInRemark = this.param?this.param.showInRemark?this.param.showInRemark:'':''
    // this.formData.id = this.param?this.param.orderId?this.param.orderId:'':''
  },
  data() {
    return {
      isdisabledSite: true,
      show3: false,
      showInRemark:"",
      dataId: '',
      nowTime:'',
      form2: {
        desc: '',
        name: "",
      },
      showOrderPop: false,
      isSendApp:false,
      drawer: true,
      formData: {
        huiFangQingKuang:null,
        huiFangQingKuangName:'',
        notTrueReasonName:'',
        notTrueReason:'',
        recallDate:'',//回访时间\
        recallMan:'',//回访员
      },
      dispatchStats: [],
      notTrueReasonList:[],
    }
  },
  mounted() {
    this.loadDictData();
  },
  methods: {
    setTimes() {
      var _this = this;
      let yy = new Date().getFullYear();
      let mm = new Date().getMonth() + 1;
      let dd = new Date().getDate();
      let hh = new Date().getHours();
      let mf = new Date().getMinutes() < 10 ? "0" + new Date().getMinutes() : new Date().getMinutes();
      let ss = new Date().getSeconds() < 10 ? "0" + new Date().getSeconds() : new Date().getSeconds();
      _this.nowTime = yy + "-" + mm + "-" + dd + " " + hh + ":" + mf + ":" + ss;
      console.log(_this.nowTime,"_this.nowTime");
      this.formData.recallDate = _this.nowTime;
    },

    radioHandleChange(val) {
      if (val == 2) {
        this.isdisabledSite = false
      } else {
        this.isdisabledSite = true
        this.formData.notTrueReason = ''
        this.formData.notTrueReasonName = ''
      }
    },

    updateNotTrueName() {
      const selectedOption = this.notTrueReasonList.find(item => item.value === this.formData.notTrueReason);
      if (selectedOption) {
        this.formData.notTrueReasonName = selectedOption.label;
      } else {
        this.formData.notTrueReasonName = null;
      }
    },

    // 加载数据字典中物流公司，运输方式
    loadDictData() {
      //不属实原因
      loadDictData(dictType.notTrueReason).then(res => {
        this.sysDictItemList = []
        res.data.data.forEach(item => {
          this.notTrueReasonList.push({
            label: item.label,
            value: item.id
          })
        })
      })
    },

    orderFollowUp() {
      if(!this.formData.huiFangQingKuang){
        this.$message({message: '请选择回访情况', type: 'warning'});
        return;
      }
      this.setTimes();
      var huiFangQingKuang = this.formData.huiFangQingKuang;
      if(huiFangQingKuang === 1){
        this.formData.huiFangQingKuangName = "属性";
      }else if(huiFangQingKuang === 2){
        this.formData.huiFangQingKuangName = "不属性";
      }else if(huiFangQingKuang === 2){
        this.formData.huiFangQingKuangName = "不确定";
      }
      this.formData.recallMan = store.getters.userInfo.username;
      console.log("用户信息-------------",store.getters.userInfo.username)
      this.drawer = false;
      this.$emit('followUpOrderRemark', this.formData)
    },
    cancelForm() {
      this.drawer = false;
      clearTimeout(this.timer);
      this.$emit('followUpOrderRemark', 0)
    },
    handleClose() {
      this.drawer = false;
      this.$emit('followUpOrderRemark', 0)
    }
  }
}
</script>
<style lang="scss" scoped>
.details2{

  ::v-deep .el-drawer .el-drawer__body {
    padding: 0 16px;
    background-color: #fff;
    position: relative;
  }

  ::v-deep .el-drawer .el-drawer__header {
    background-color: #fff;
  }

  ::v-deep .el-drawer__container {
    position: relative;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
    background: aliceblue;
    background-color: rgb(38 38 38 / 70%);
  }

  #containt .table-detail {
    border-collapse: collapse;
    font-size: 12px;
    border: 1px solid #ededed;
  }

  .btn {
    text-align: center;
  }
  //   3个标签
  .information {
    padding: 0px 10px;
    background-color: #E1F2FF;
    color: #268AEA;
    border-radius: 3px;
    margin: 0 5px;
    font-size: 15px;
  }
  //   每个分支
  .d-item {
    border: 1px solid #ededed;
    padding-bottom: 5px;

    .title b {
      display: inline-block;
      line-height: 20px;
      font-size: 13px;
      font-weight: 600;
      margin-right: 84px;
      vertical-align: middle;
      color: rgb(42, 100, 148);
      position: relative;
      z-index: 2;
      background: rgba(42, 100, 148, 0.16);
      margin-left: 0px;
      margin-bottom: 8px;
      padding-left: 12px;
      padding-right: 14px;
      border-radius: 0px 28px 28px 0px;
    }
    .table-detail tr {
      margin-bottom: 10px;
      display: block;
      th {
        font-weight: 400;
        text-align: right;
        width: 7vw !important;
        font-size: 12px;
        position: relative;
        padding: 0 5px 0 4px;
        color: rgba(86, 86, 86, 0.96);
      }
      td {
        font-weight: 400;
        // text-align: right;
        width: 10vw !important;
        font-size: 12px;
        position: relative;
        padding: 0 0px 0 4px;
        color: rgba(0, 0, 0,);
      }
    }}

  ::v-deep .el-image__preview {
    width: 60px !important;
    height: 60px !important;
  }

  .pic_main {
    display: flex;
    margin-left: 20px;
    margin-top: 10px;

    .pic_item {
      display: flex;
      margin-right: 40px;

      span {
        white-space:nowrap;
        line-height: 60px;
        font-size: 12px;
        color: rgba(86, 86, 86, 0.96);
        font-weight: 400;

      }
    }
  }

  // 本单费用位置
  .expense {
    position: absolute;
    right: 20%;
    margin-top: 5px;
    color: #00c4b3;
    font-size: 13px;
  }
  // 滚动条样式

  /* 滚动条 */
  ::-webkit-scrollbar {
    width: 5px;
    height: 12px;
  }

  /* 滚动槽 */
  ::-webkit-scrollbar-track {
    border-radius: 0px;
    // background: rgba(224, 7, 7, 0.05);
  }

  /* 滚动条滑块 */
  ::-webkit-scrollbar-thumb {
    border-radius: 00px;
    background: #cfcece;
  }

  // 步骤条 圆的位置
  ::v-deep .el-timeline-item__node--normal {
    left: 0px !important;
    width: 12px;
    height: 12px;
  }
  ::v-deep  .el-step__title {
    font-size: 13px!important;
    line-height: 38px;
  }
}
</style>
